import React, { useState } from 'react';
import { KeyRound } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Standalone login form for /admin. Extracted from AdminPanel.jsx on
 * 28/05/2026. Pure presentational + auth fetch — receives `onLogin`
 * which the parent uses to store the token + admin user.
 */
export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        setError(err.detail || 'Identifiants invalides');
        setLoading(false);
        return;
      }
      const data = await res.json();
      onLogin(data);
    } catch (e) {
      setError(`Erreur réseau : impossible de contacter le serveur. (${e.message || 'Vérifiez votre connexion'})`);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-ink-700/30 flex items-center justify-center p-4" data-testid="admin-login">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 bg-accent text-white px-4 py-2 rounded-full text-sm font-bold">
            <KeyRound className="w-4 h-4" /> HST Admin
          </div>
        </div>
        <div className="bg-ink-800 rounded-xl p-6">
          <h2 className="font-bold text-slate-100 mb-4">Connexion administrateur</h2>
          <form onSubmit={handleSubmit} className="space-y-3">
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" className="w-full bg-background text-foreground placeholder-slate-500 border border-ink-600 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-accent" data-testid="admin-email" />
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Mot de passe" className="w-full bg-background text-foreground placeholder-slate-500 border border-ink-600 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-accent" data-testid="admin-password" />
            {error && <p className="text-xs text-danger bg-danger/10 rounded p-2" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} className="w-full bg-accent text-white py-2.5 rounded-lg font-bold text-sm disabled:opacity-50 hover:bg-accent-hover transition-colors" data-testid="admin-login-submit">
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
